import React from 'react';

const Stage = ({ view, scratcherPosition, incScratcherPos, decScratcherPos, changeView }) =>  (
  <div className="stage">
      <div className="stage__wall">
          <div className="stage__wall-pattern"></div>
          <div className="stage__wall-shadow"></div>
          <div className="stage__wall-outlet"></div>
      </div>
      <div className="stage__floor">
          <div className="stage__floor-wood">
              <div className="stage__floor-wood-pattern"></div>
          </div>
      </div>
      <div className="stage__lighting js-stage-lighting">
          <div className="stage__lighting-wreath"></div>
      </div>
      <div className="stage__lighting-mask js-lighting-mask"></div>
      <div className="stage__lighting-swatch"></div>
  </div>
);

export default Stage;



/** WEBPACK FOOTER **
 ** ./src/components/Stage/Stage.js
 **/